
import { Component, Vue } from "vue-property-decorator";
import { Getter } from 'vuex-class'
import Logo from "./components/Logo.vue";
import ContractPopup from "./components/ContractPopup.vue";
import { login } from '@/api/login'
import { encryptData } from "@/utils/encryptData";
import { validatePhoneNumber } from "@/utils/util";
import { pxToVw } from '@/utils/pxToVw'
import { enterSystem } from './login'
import store from '@/store'
import { setAllowsBackGesture } from "@/utils/h5ToApp";

@Component({
  components: { Logo, ContractPopup }
})
export class PwdLogin extends Vue {
  @Getter topSafetyHeight!: number

  mobile = ''
  pwd = ''
  pwdFieldType = 'password'
  isAgree = false
  errShakeClass = 'animate__animated animate__headShake'
  isMobileErr = false
  isPwdErr = false
  loginData = null // 登录成功获取到的数据

  get topSafetyHeightCss (): string {
    return pxToVw(this.topSafetyHeight)
  }

  created () {
    this.$store.commit('addKeepAlive', 'PwdLogin')
  }

  mounted () {
    // 禁用侧滑返回
    setAllowsBackGesture('0');
  }

  onMobileFocus () {
    this.isMobileErr = false
  }

  onMobileBlur (value: string) {
    if (value) {
      this.isMobileErr = !validatePhoneNumber(value)
    }
  }

  toPath (path: string) {
    this.$router.push(path)
  }

  onLogin () {
    this.isPwdErr && (this.isPwdErr = false)
    const params = {
      username: encodeURIComponent(encryptData(this.mobile)),
      password: encodeURIComponent(encryptData(this.pwd))
    }
    login(params).then((res) => {
      this.loginData = res.data
      if (!this.isAgree) {
        (this.$refs.contractPopupRef as any).showPopup()
        return
      }
      this.loginSuccess()
    }).catch((err) => {
      if (err.data.code === '000001') {
        this.isPwdErr = true
      }
    })
  }

  loginSuccess () {
    // 缓存信息
    store.dispatch('GetInfo', this.loginData)
    store.dispatch('setFirstUserId', this.loginData.userId)
    this.$store.commit('delKeepAlive', 'PwdLogin')
    // 登录账号和密码存储，下次登录回填
    store.dispatch('setLoginInfo', { mobile: this.mobile, password: this.pwd })
    // 进入系统
    enterSystem('pwdLogin')
  }

  onSmsCodeLogin () {
    this.$router.replace('/login')
    this.$store.commit('delKeepAlive', 'PwdLogin')
  }

  onFindPwd () {
    this.$router.replace('/findPwd')
    this.$store.commit('delKeepAlive', 'PwdLogin')
  }

  onYesContract () {
    this.isAgree = true
    this.loginSuccess()
  }
}
export default PwdLogin
